module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/profiles/profiles.component.scss
// module id = 585
// module chunks = 1